import React from 'react'
// import style  from '../../styles/mystyle.module.css'
import { useTranslation } from "next-i18next";
import LoadingButton from "@mui/lab/LoadingButton"
// import { makeStyles } from "@mui/styles"
import styled from "@mui/system/styled"
const Customebtn = styled(LoadingButton)({
  whiteSpace: "break-spaces",
  letterSpacing: "initial !important",
  textDecoration:"none",
    '&.Mui-disabled': {
      color: "grey !important",
      border: "none !important",
      backgroundColor: "#bcbcbc70 !important",
  
  },
  '&:hover':{
       
          border:"none"
  },
  '@media (min-width:100px) and (max-width:768px)': {
  backgroundColor:" #008C8D  !important",
  fontSize:"1rem !important",
  width:"190px !important  ",
  border:"none !important",
  height:"1.0375em",
     boxSizing: "content-box !important",
     padding:" 12px 14px !important", 
      borderRadius:'6px !important',
      margin:"auto !important",
      display:"flex !important",},
 
  '@media (min-width:768px) and (max-width:912px)': {
   
 
    backgroundColor:" #008C8D  !important",
    fontSize:"1rem !important",
    width:"190px !important", 
    height:"1.0375em",
      boxSizing: "content-box !important",
      padding:" 12px 14px !important" , 
       borderRadius:'6px !important',
       border:"none !important",
       margin:"auto !important",
       display:"flex !important"

   
},
'@media (min-width:913px) ': {
    

    backgroundColor:" #008C8D  !important",
    fontSize:"1.2rem !important",
    width:"320px !important", 
    height:"1.0375em",
      boxSizing: "content-box !important",
      padding:" 12px 14px !important" , 
       borderRadius:'6px !important',
       border:"none !important",
       margin:"auto !important",
       display:"flex !important"



},
  
  });
function SeeMore({getMore,loading,text}) {
    const { t } = useTranslation("common");
    return (
        <div >
           <Customebtn   loading={loading} onClick={getMore} sx={{color:"white"}} variant="outlined" loadingPosition={"start"}>
           {text?text:t("SeeMore")}
                                </Customebtn> 
                                
        </div>
    )
}

export default SeeMore
